// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"448":"632b6370","4580":"90101d77","6704":"6941c303","8291":"b5c4b46e"}[chunkId] + ".chunk.css";
};